import { H4, ParagraphBody } from '@by-miles/bymiles-styles'

import { ExplainerSectionStyles } from './ExplainerSectionStyles'

interface ExplainerSectionProps {
  imageUrl: string
  title: string
  text: string
}

export const ExplainerSection = ({ imageUrl, title, text }: ExplainerSectionProps) => {
  return (
    <ExplainerSectionStyles>
      <div className="section">
        <img src={`${imageUrl}@3x.png`} alt="explainer" className="image" />
        <div className="content">
          <H4 className="title">{title}</H4>
          <ParagraphBody className="text">{text}</ParagraphBody>
        </div>
      </div>
    </ExplainerSectionStyles>
  )
}
